import T from 'i18n-react';
import React, { Component } from 'react';
import ReactPlaid from "react-plaid";
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import validator from 'validator';
import { PaymentValidationResult } from '../../constants/PaymentValidationResultConstants';
import { PaymentVendorProcessType } from '../../constants/PaymentVendorProcessTypeConstants';
import * as AccountStore from '../../store/Account';
import * as CommonStore from '../../store/Common';
import * as PaymentStore from '../../store/Payment';
import ConfirmModal from '../shared/ConfirmModal';
import ExternalLink from '../shared/ExternalLink';
import LoadingButton from '../shared/LoadingButton';
import LoadingOverlay from '../shared/LoadingOverlay';
import MessageError from '../shared/MessageError';
import PaymentSummary from '../shared/PaymentSummary';
import SuggestedPayment from '../shared/SuggestedPayment';
import IFrameManager from './IFrameManager';
import { PaymentAccountOption } from './PaymentAccountOption';
import { PaymentAccountSingleValue } from './PaymentAccountSingleValue';
import PaymentSidebar from './PaymentSidebar';

const Scroll = require('react-scroll');
const card = require(`../../images/${process.env.REACT_APP_CLIENT}/card.png`);
const paymentIcon = require(`../../images/${process.env.REACT_APP_CLIENT}/payment-icon.png`);

const Recaptcha = require('react-recaptcha');

const PaySteps = Object.freeze({
    Step1PaymentSummary: 1,
    Step2PaymentSending: 2,
    Step3PaymentConfirmation: 3
});

class PayECheck extends Component {

    constructor(props) {
        super(props);

        this.recaptchaRef = React.createRef();

        this.state = {
            step: PaySteps.Step1PaymentSummary,
            sentToBackend: false,
            valid_captcha: false,
            anotherPaymentMethod: true,
            tenderTypeID: 2,
            amountOptionID: "2",
            amount: '',
            accountNumber: '',
            routingNumber: '',
            nameOnAccount: '',
            bankAccountType: '0',
            reactPlaidOpen: false,
            account_id: '',
            open: false,
            fields: [
                { name: 'accountNumber', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, paymentStripeRequired: false },
                { name: 'routingNumber', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, paymentStripeRequired: false },
                { name: 'account_id', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, paymentStripeRequired: true },
                { name: 'nameOnAccount', isRequired: true, conditionField: 'anotherPaymentMethod', conditionValue: true, paymentStripeRequired: false, minTextWords: 2 }
            ],
            totalPayment: 0,
            accountPaymentDistributions: [],
            paymentChargeFee: {}
        };
    }

    componentWillMount = () => {
        Scroll.animateScroll.scrollToTop({ smooth: true, duration: 500 });
        document.title = T.translate('common.client') + ' | ' + T.translate('accountPay.titleCheck');

        this.props.resetPaymentValidation();

        // Initialize app and load account data
        this.props.init();
        this.props.setAccount();
    }

    componentDidMount = () => {
        const { companyID, suggestedPaymentObject, hasRequestedPaymentAccounts, account } = this.props;

        if (companyID) {
            let userName = account.accountNumber;
            if (account.person) {
                let person = account.person;
                userName = person.emailAddress;
            }

            const request = {
                actions: ['iFrameSettings'],
                companyID: companyID,
                accountID: account.accountID,
                accountNumber: account.accountNumber,
                userName: userName,
                tenderTypeID: 2,
                paymentVendorProcessTypeID: PaymentVendorProcessType.RegularPayment,
                isPayment: true
            };

            this.props.runHostedPaymentPageActions(request);

            if (!hasRequestedPaymentAccounts) {
                this.props.getPaymentAccounts();
            }

            if (!suggestedPaymentObject || !suggestedPaymentObject.hasOwnProperty('suggestedPaymentAmount')) {
                this.props.getSuggestedPaymentObject();
            }

            if (this.props.systemProperties && this.props.systemProperties.isLoaded) {
                this.setState({
                    paymentChargeFee: this.getPaymentChargeFeeObj(this.props.systemProperties.eCheckCharge)
                });

                if (this.props.systemProperties.myAcctReCaptchaDisabled && !this.props.enableAuthenticatePaymentInfo) {
                    this.props.authorizeAccountPaymentByPass();
                }
            }
        }
    }

    componentDidUpdate = async (prevProps) => {
        const { account, companyID, useHostedPaymentPage, suggestedPaymentObject, systemProperties, hasRequestedPaymentAccounts } = this.props;

        // When account number is loaded or changed
        if (account.accountNumber && account.accountNumber !== prevProps.account.accountNumber) {

            const accountsWereCleared = !hasRequestedPaymentAccounts && !prevProps.hasRequestedPaymentAccounts;

            if (accountsWereCleared) {
                // Payment accounts were cleared (e.g., after logout or navigation), trigger reload
                this.props.getPaymentAccounts();
            }

            if (!suggestedPaymentObject || !suggestedPaymentObject.hasOwnProperty('suggestedPaymentAmount')) {
                this.props.getSuggestedPaymentObject();
            }
        }

        // When companyID becomes available
        if (companyID && companyID !== prevProps.companyID) {
            let userName = account.accountNumber;
            if (account.person) {
                let person = account.person;
                userName = person.emailAddress;
            }

            const request = {
                actions: ['iFrameSettings'],
                companyID: companyID,
                accountID: account.accountID,
                accountNumber: account.accountNumber,
                userName: userName,
                tenderTypeID: 2, // eCheck
                paymentVendorProcessTypeID: PaymentVendorProcessType.RegularPayment,
                isPayment: true
            };
            await this.props.runHostedPaymentPageActions(request);
        }

        if (systemProperties.isLoaded && !prevProps.systemProperties.isLoaded) {
            this.setState({ paymentChargeFee: this.getPaymentChargeFeeObj(systemProperties.eCheckCharge) });

            if (this.props.systemProperties.myAcctReCaptchaDisabled && !this.props.enableAuthenticatePaymentInfo) {
                this.props.authorizeAccountPaymentByPass();
            }
        }

        // Logic to automatically advance to the next step after validation
        if (this.state.step === PaySteps.Step1PaymentSummary) {
            const { paymentValidationResult } = this.props;
            if (useHostedPaymentPage && paymentValidationResult === PaymentValidationResult.Approved && this.props.paymentAttemptID > 0) {
                this.setState({ step: PaySteps.Step2PaymentSending });
            }
        }

        if (this.props.paymentErrorMessage) {
            Scroll.animateScroll.scrollToBottom({ smooth: true, duration: 500 });
        }
    }


    onChange = (e) => {

        let fields = this.state.fields.filter(x => x.name === e.target.name);
        if (fields && fields.length === 1) {
            let field = fields[0];

            if (field.isRequired && field.isRequiredError && e.target.value) {
                if (field.minTextWords) {
                    var words = e.target.value.trim().split(' ');
                    if (words.length >= field.minTextWords) {
                        field.isRequiredError = false;
                    }
                }
                else {
                    field.isRequiredError = false;
                }
            }

            if (field.isNumeric && e.target.value) {
                e.target.value = CommonStore.getNumericInputText(e.target.value);
            }

            if (field.isNumeric && e.target.value) {
                if (validator.isDecimal(e.target.value)) {
                    field.isNumericError = false;
                }
            }
        }

        this.setState({ [e.target.name]: e.target.value });
    }

    isFormValid = () => {

        var state = this.state;
        var valid = true;
        var paymentStripeRequired = this.props.paymentStripe ? true : false;

        if (!state.anotherPaymentMethod && !this.props.accountPayEcheckPaymentAccount) {
            return false;
        }

        this.state.fields.map((field) => {
            if (field.conditionField && field.conditionValue === state[field.conditionField] && (field.paymentStripeRequired === paymentStripeRequired || field.paymentStripeRequired === 'always')) {
                field.value = this.state[field.name];
                field.isRequiredError = false;

                if (field.isRequired) {
                    if (!field.value) {
                        field.isRequiredError = true;
                        valid = false;
                    } else {
                        if (field.minTextWords) {
                            var words = field.value.trim().split(' ');
                            if (words.length < field.minTextWords) {
                                field.isRequiredError = true;
                                valid = false;
                            }
                        }
                    }
                }

                if (field.isNumeric && field.value) {
                    if (!validator.isDecimal(field.value)) {
                        field.isNumericError = true;
                        valid = false;
                    }
                }
            }

            return field;
        });

        this.setState(state);

        if (valid) {
            this.props.setPaymentError('');
        } else {
            this.props.setPaymentError(T.translate("common.thereAreMissingFields"));
        }

        return valid;
    }

    verifyCallback = (response) => {
        if (response) {

            this.setState({ valid_captcha: true });

            if (!this.props.enableAuthenticatePaymentInfo) {
                this.props.authorizeAccountPaymentByPass();
            }
        }
        else {
            this.setState({ valid_captcha: false });
        }
    }

    expiredAuthPaymentRecaptcha = () => {
        this.setState({ valid_captcha: false });
        this.props.authorizeAccountPaymentExpired();
    }

    verifyCardInfo = () => {
        if (this.isFormValid()) {
            this.props.authorizeAccountPayment(this.state);
        }
    }

    pay = () => {
        // Check if amount is zero or empty
        const paymentAmount = this.state.totalPayment || this.state.amount;
        if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
            this.props.setPaymentError(T.translate('accountPay.amountMustBeGreaterThanZero') || 'Payment amount must be greater than zero to proceed.');
            return;
        }

        if (this.isFormValid()) {
            if (this.props.showPaymentAmountWarning && this.props.account.accountBillingTypeID === 2 && this.totalPayment > this.props.account.totalAmountDue) {
                this.setState({ open: true });
            } else {
                this.postAccountPay();
            }
        }
    }

    postAccountPay = () => {
        this.setState({ open: false });
        this.props.postAccountPay(this.state);
    }

    goToDashboard = (e) => {
        this.props.toggleAccountPaymentSuccessModal();
        this.props.setAccount();
        this.props.clearPaymentState();
        this.props.history.push('/myaccount/dashboard');
    }

    handleChange = (selectedOption) => {
        this.props.changeEcheckPaymentAccount(selectedOption);
        this.setState({
            anotherPaymentMethod: false,
            valid_captcha: false  // Reset CAPTCHA when switching to stored payment method
        });
        // Reset authorization when switching payment methods
        this.props.authorizeAccountPaymentExpired();
        // Reset reCAPTCHA visually
        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
    }

    handleClick = (e) => {
        e.preventDefault();
        this.props.changeEcheckPaymentAccount({});
        this.setState({
            anotherPaymentMethod: true,
            valid_captcha: false  // Reset CAPTCHA when switching to new payment method
        });
        // Reset authorization when switching payment methods
        this.props.authorizeAccountPaymentExpired();
        // Reset reCAPTCHA visually
        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
    }

    reactPlaidSuccess = (token, metaData) => {
        this.setState({ account_id: metaData.account_id, public_token: metaData.public_token, reactPlaidOpen: false });
    }

    open = () => {
        this.setState({ open: true });
    }

    close = () => {
        this.setState({ open: false });
    }

    handleTotalAmountCalculation = (totalPaymentAmount, accountPaymentDistributions) => {
        this.setState({ totalPayment: totalPaymentAmount }, function () {
            this.setState({ accountPaymentDistributions: accountPaymentDistributions });
        });
    }

    getPaymentChargeFeeObj = (chargeFeeFromInit) => {
        let paymentChargeFee = {
            paymentMethod: T.translate('suggestedPayment.paymentsIncurseCheck'),
            chargeFee: chargeFeeFromInit
        }

        return paymentChargeFee;
    }

    onTokenizeCreditDetailsClick = (e) => {
        this.setState({ tokenizeCreditDetails: !this.state.tokenizeCreditDetails });
    }

    next = async () => {
        var { step } = this.state;

        if (step === PaySteps.Step1PaymentSummary) {
            const { useHostedPaymentPage, paymentValidationResult } = { ...this.props };

            if (useHostedPaymentPage) {
                if (paymentValidationResult === PaymentValidationResult.Unset) {
                    const account = { ...this.props.account };
                    const tenderTypeID = parseInt(this.state.tenderTypeID);
                    const paymentVendorProcessTypeID = PaymentVendorProcessType.RegularPayment; // One-time payment

                    const request = {
                        actions: ['paymentValidation'],
                        accountID: account.accountID,
                        accountNumber: account.accountNumber,
                        companyID: this.props.companyID,
                        amount: this.state.totalPayment || this.state.amount || 0.0,
                        tenderTypeID,
                        paymentVendorProcessTypeID,
                        keepLoadingSpinner: true
                    };
                    await this.props.runHostedPaymentPageActions(request);
                }
            } else {
                this.setState({ step: PaySteps.Step2PaymentSending });
            }
        }
    }

    back = async () => {
        const { step } = this.state;
        const { useHostedPaymentPage } = { ...this.props };

        if (step === PaySteps.Step2PaymentSending && useHostedPaymentPage) {
            this.props.resetPaymentValidation();
        }

        this.setState({ step: step - 1 });
    }

    onIFrameLoaded = () => {
        if (!this.state.sentToBackend) {
            this.props.hideLoadingSpinner();
        }
    }

    // iFrame related methods for eCheck
    onIFrameResponse = (response) => {
        this.props.setIFrameResponse(response);

        if (!response.error && response.token) {
            this.setState({ iFramePaymentToken: response.token });
            this.props.setPaymentError('');
        } else {
            this.props.setPaymentError(response.error || 'Payment form error occurred');
        }
    }

    onIFramePaymentSuccess = (response) => {
        let state = { ...this.state };

        // Prepare payment data with iframe token for eCheck
        let paymentData = {
            ...state,
            paymentToken: response.token,
            paymentMethod: 'iFrameECheck',
            amount: state.totalPayment || state.amount,
            tenderTypeID: 2, // eCheck tender type
            // New parameters for hosted payment page - use the exact field names from requirements
            isHostedPaymentPageResponse: true,
            hostedPaymentPageResponse: response.transactionResponse || '',
            // Additional reference fields for tracking
            referenceNumber: `${response.vendor} Payment - ${response.operation || 'BA'}`,
            notes: `${response.vendor} Payment - Account: ${response.accountName || 'N/A'}`,
            // For eCheck, only send CardNumber with the account number from iframe response
            accountNumber: response.accountNumber || ''
        };

        if (response.nameOnAccount)
            paymentData.nameOnAccount = response.nameOnAccount;

        this.setState({ sentToBackend: true });

        // Process the payment
        this.props.postAccountPay(paymentData);
    }

    render() {
        const isLoading = this.props.paymentLoading || this.props.accountSummaryLoading;
        const amountToPay = this.state.totalPayment || this.state.amount || 0.0;
        const { paymentAccounts, suggestedPaymentObject } = this.props;
        const isSelectedPaymentAccount = this.props.accountPayEcheckPaymentAccount.paymentAccountID > 0;

        return (
            <div className="payment-section">

                <div className="left-sidebar">
                    <div className="p-main">

                        <LoadingOverlay loading={isLoading} />

                        <div className="page-header">
                            <div className="page-title">{T.translate('accountPay.pageTitleCheck')}</div>
                            <p className="lead text-dark">{T.translate('accountPay.welcomePaymentSystemCheck', this.props.systemProperties)}</p>
                        </div>
                        <div className="diverter" />

                        {/* divStep1PaymentSummary */}
                        <div id="divStep1PaymentSummary" className="step1Payment" style={{ display: this.state.step === PaySteps.Step1PaymentSummary ? 'block' : 'none' }}>
                            <h6 className="card-title">{T.translate('accountPay.infoAsOf')} {CommonStore.formatDate(new Date())}</h6>

                            <div className="card bl-blue mb-4 mb-sm-5">
                                <div className="card-body pay-card">
                                    <img src={card} alt="card" />
                                    {this.props.account.accountBillingTypeID === 1 &&
                                        <ul>
                                            <li>
                                                <span>{T.translate('accountPay.accountNumber')}</span>
                                                <strong>{this.props.account.accountNumber}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.customerName')}</span>
                                                <strong>{this.props.account.primaryPersonName}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.amountBelowThreshold')}</span>
                                                <strong>${CommonStore.formatDecimal(this.props.account.disconnectThreshold)}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.availableBalance')}</span>
                                                <strong className={this.props.account.availableBalance > 0 ? "text-success" : "text-danger"}>${CommonStore.formatDecimal(this.props.account.availableBalance)} {this.props.account.availableBalance > 0 && <span className="text-success font-weight-bold"> {T.translate('dashboard.credit')}</span>}</strong>
                                            </li>
                                        </ul>
                                    }

                                    {this.props.account.accountBillingTypeID !== 1 &&
                                        <ul>
                                            <li>
                                                <span>{T.translate('accountPay.accountNumber')}</span>
                                                <strong>{this.props.account.accountNumber}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.customerName')}</span>
                                                <strong>{this.props.account.primaryPersonName}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.pastDueCharges')}</span>
                                                <strong>${CommonStore.formatDecimal(this.props.account.pastDueAmount)}</strong>
                                            </li>
                                            <li>
                                                <span>{T.translate('accountPay.totalAccountBalance')}</span>
                                                <strong className={this.props.account.accountBalance < 0 ? "text-danger" : "text-success"}>${CommonStore.formatDecimal(this.props.invertBalance ? Math.abs(this.props.account.accountBalance) : this.props.account.accountBalance)} {this.props.account.accountBalance > 0 && <span className="text-success font-weight-bold"> {T.translate('dashboard.credit')}</span>}</strong>
                                            </li>
                                        </ul>
                                    }

                                </div>
                            </div>

                            <h6 className="card-title mb-4">{T.translate('accountPay.paymentAmount')}</h6>

                            <SuggestedPayment
                                key={`suggested-${this.props.account.accountID || 'none'}`}
                                suggestedPaymentObject={suggestedPaymentObject}
                                onFinishTotalAmountCalculation={this.handleTotalAmountCalculation}
                                paymentChargeFee={this.state.paymentChargeFee} />

                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-lg-12">
                                    <PaymentSummary amount={amountToPay} />
                                </div>
                            </div>

                            <MessageError>{this.props.paymentErrorMessage}</MessageError>

                            <LoadingButton
                                className="btn btn-primary btn-lg pull-right"
                                disabled={isLoading || amountToPay <= 0}
                                loading={isLoading ? 'true' : 'false'}
                                onClick={this.next}>
                                {T.translate('quickPay.nextStep')}
                            </LoadingButton>
                        </div>

                        {/* Step2PaymentSending */}
                        <div id="divStep2PaymentSending" style={{ display: this.state.step === PaySteps.Step2PaymentSending ? 'block' : 'none' }}>
                            <div className="custom-control custom-checkbox credit-card-checkbox-outer checked">
                                <div className="credit-card-paybox">

                                    <div className="row" style={{ marginTop: '20px' }}>
                                        <div className="col-lg-12">
                                            <PaymentSummary amount={amountToPay} />
                                        </div>
                                    </div>

                                    <div className="row" style={{ marginTop: '20px' }}>

                                        <div className="col-sm-6">
                                            <h6 className="card-title">{T.translate('accountPay.useStoredPaymentMethod')}</h6>
                                        </div>
                                        <div className="col-sm-6 text-left text-sm-right">
                                            <NavLink to="/myaccount/paymentmethods" className="payment-link mb-3 d-inline-block">
                                                <img src={paymentIcon} alt="payment" /><span>{T.translate('autopay.addPaymentMethod')}</span>
                                            </NavLink>
                                            &nbsp;&nbsp;
                                            {this.props.accountPayEcheckPaymentAccount.paymentAccountID && <a href="#" onClick={this.handleClick} className="payment-link mb-3 d-inline-block"><span>{T.translate('accountPay.clearSelectedOption')}</span></a>}
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <Select
                                                    value={this.props.accountPayEcheckPaymentAccount}
                                                    onChange={this.handleChange}
                                                    components={{ Option: PaymentAccountOption, SingleValue: PaymentAccountSingleValue }}
                                                    options={(paymentAccounts || []).filter(x => x.paymentAccountTypeID === 4)}
                                                    isSearchable={false}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {!this.props.accountPayEcheckPaymentAccount.paymentAccountID && <div className="">

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h6 className="card-title">{T.translate('accountPay.orMakeOneTimePayment')}</h6>
                                            </div>
                                        </div>

                                        {/* Hide traditional eCheck form when using hosted payment page */}
                                        {!this.props.useHostedPaymentPage && (
                                            <div>
                                                {!this.props.paymentStripe && <div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="accountNumber">{T.translate('accountPay.bankAccountNumber')}</label>
                                                                <input type="text" id="accountNumber" maxLength={17} name="accountNumber" value={this.state.accountNumber} onChange={this.onChange} className={"form-control " + (this.state.fields[0].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                                <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="bankAccountType">{T.translate('autopay.bankAccountType')}</label>
                                                                <select className="form-control" id="bankAccountType" name="bankAccountType" value={this.state.bankAccountType} onChange={this.onChange}>
                                                                    {
                                                                        this.props.systemProperties.bankAccountTypes.map(function (type) {
                                                                            return <option key={type.value} value={type.value}>{type.name}</option>;
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="nameOnAccount">{T.translate('autopay.accountHolderName')}</label>
                                                                <input type="text" id="nameOnAccount" name="nameOnAccount" value={this.state.nameOnAccount} onChange={this.onChange} className={"form-control " + (this.state.fields[3].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                                <div className="invalid-feedback">{T.translate('accountPay.holderNameRequired')}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="routingNumber">{T.translate('accountPay.routingNumber')}</label>
                                                                <input id="routingNumber" name="routingNumber" maxLength={9} value={this.state.routingNumber} onChange={this.onChange} className={"form-control " + (this.state.fields[1].isRequiredError ? 'is-invalid' : '')} autoComplete="off" />
                                                                <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}

                                                {this.props.paymentStripe && <div>

                                                    <div className="row form-group">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <button className="btn" onClick={() => this.setState({ reactPlaidOpen: true })}>{T.translate('accountPay.clickSelectBankAccount')}</button>
                                                                {this.state.fields[2].isRequiredError && <div className="invalid-feedback" style={{ display: 'block' }}>{T.translate('common.thisFieldIsRequired')}</div>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <ReactPlaid
                                                        clientName={this.props.paymentStripe.clientName}
                                                        product={this.props.paymentStripe.product}
                                                        apiKey={this.props.paymentStripe.apiKey}
                                                        env={this.props.paymentStripe.env}
                                                        selectAccount={this.props.paymentStripe.selectAccount}
                                                        open={this.state.reactPlaidOpen}
                                                        onSuccess={(token, metaData) => this.reactPlaidSuccess(token, metaData)}
                                                        onExit={() => this.setState({ reactPlaidOpen: false })}
                                                    />
                                                </div>}
                                            </div>
                                        )}

                                        {/* Show iFrame component for eCheck if useHostedPaymentPage is true */}
                                        {this.props.useHostedPaymentPage && this.state.step === PaySteps.Step2PaymentSending && (
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <IFrameManager
                                                        sourceName="PayECheck"
                                                        key={`echeck-${this.props.account && this.props.account.accountID}`}
                                                        paymentMethod="eCheck"
                                                        paymentProviderID={this.props.paymentProviderID}
                                                        paymentVendorProcessTypeID={PaymentVendorProcessType.RegularPayment}
                                                        amount={amountToPay}
                                                        sourceAccount={this.props.account}
                                                        onLoaded={this.onIFrameLoaded}
                                                        companyID={this.props.companyID}
                                                        content={this.props.hostedPaymentPageContent}
                                                        onIFrameResponse={this.onIFrameResponse}
                                                        onPaymentSuccess={this.onIFramePaymentSuccess}
                                                        setPaymentError={this.props.setPaymentError}
                                                        setIFrameToken={this.props.setIFrameToken}
                                                        hideBorder={true}
                                                        disabled={(!this.state.totalPayment || this.state.totalPayment == 0) && (!this.state.amount || this.state.amount == 0)}
                                                        paymentAttemptID={this.props.paymentAttemptID}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>}

                                    {/* Show reCAPTCHA when not using hosted payment page OR when using stored payment method */}
                                    {(!this.props.useHostedPaymentPage || isSelectedPaymentAccount) && (
                                        <div className="row">
                                            {!this.props.systemProperties.myAcctReCaptchaDisabled && <div className="col-sm-6">
                                                <Recaptcha
                                                    ref={this.recaptchaRef}
                                                    sitekey={this.props.systemProperties.reCaptchaKey}
                                                    verifyCallback={this.verifyCallback}
                                                    expiredCallback={this.expiredAuthPaymentRecaptcha}
                                                    expireTimeMs={10000}
                                                />
                                            </div>}

                                            {this.props.enableAuthenticatePaymentInfo && <div className="col-sm-6">
                                                <LoadingButton
                                                    type="button"
                                                    className="btn btn-outline-dark m-2"
                                                    loading={this.props.authorizeAccountPaymentLoading ? 'true' : 'false'}
                                                    disabled={(!this.props.systemProperties.myAcctReCaptchaDisabled && !this.state.valid_captcha) || this.props.authPaymentExpired || this.props.authPaymentVerified}
                                                    onClick={this.verifyCardInfo}>
                                                    Authorize
                                                </LoadingButton>
                                            </div>}

                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="clearfix mb-4" />

                            {T.translate('accountPay.byClickingPaymentYouAgree') && <p>
                                {T.translate('accountPay.byClickingPaymentYouAgree')} <ExternalLink href={this.props.systemProperties.marketerTosUrl} className="a-link">{T.translate('accountPay.termsOfService')}</ExternalLink>
                                {T.translate('accountPay.andUnderstandThePrivacyStatement')} <NavLink to="/myaccount/plandocuments" className="a-link">{T.translate('accountPay.yourRightsAsCustomer')}</NavLink>
                            </p>}

                            {!this.props.account.isCashOnly && this.props.authPaymentVerified && !isSelectedPaymentAccount && !this.props.useHostedPaymentPage && <div>
                                <div>
                                    <p>{T.translate("accountPay.tokenizeCreditDetails")}</p>
                                </div>

                                <div className="checkbox">
                                    <label>
                                        <input className="coupon_question sign-up-checkbox mr-1" name="tokenizeCreditDetails" id="tokenizeCreditDetails" value="1" type="checkbox" checked={this.state.tokenizeCreditDetails} onClick={this.onTokenizeCreditDetailsClick} />
                                        {T.translate("accountPay.agreeOnTokenizeCreditDetails")}
                                    </label>
                                </div>
                            </div>}

                            <button type="button" className="btn" disabled={isLoading} onClick={this.back}>{T.translate('common.back')}</button>

                            {/* Show submit button when not using hosted payment page OR when using stored payment method */}
                            {!this.props.account.isCashOnly && (!this.props.useHostedPaymentPage || isSelectedPaymentAccount) && <LoadingButton
                                type="button"
                                className="btn btn-primary btn-lg pull-right"
                                disabled={this.props.paymentLoading || (!this.props.systemProperties.myAcctReCaptchaDisabled && !this.state.valid_captcha) || !this.props.authPaymentVerified || (!isSelectedPaymentAccount && !this.state.tokenizeCreditDetails)}
                                loading={this.props.paymentLoading ? 'true' : 'false'}
                                onClick={this.pay}>
                                {T.translate('accountPay.submitPayment')}
                            </LoadingButton>}

                            <MessageError>{this.props.paymentErrorMessage}</MessageError>

                        </div>
                    </div>
                </div>

                <ConfirmModal
                    title={T.translate('accountPay.paymentAccepted')}
                    open={this.props.showAccountPaymentSuccessModal}
                    onToggle={this.goToDashboard}
                    loading={this.props.paymentLoading}>
                    <div>
                        <p>{T.translate('accountPay.yourPaymentHasBeenAccepted')}</p>
                        <p className="font-weight-bold">{T.translate('accountPay.yourPaymentConfirmationNumberIs')}</p>
                        <p>{this.props.accountPayConfirmationNumber}</p>
                    </div>
                </ConfirmModal>

                <ConfirmModal
                    title={T.translate('accountPay.paymentWarning')}
                    open={this.state.open}
                    onToggle={this.close}
                    onConfirm={this.postAccountPay}
                    confirmButtonText={T.translate('accountPay.yesSubmitPayment')}>
                    <div><p>{T.translate('accountPay.areYouSureWantPayMoreAmountDue')}</p></div>
                </ConfirmModal>

                <PaymentSidebar />
            </div>
        );
    }
}

export default connect(
    state => ({ ...state.account, ...state.common, ...state.payment }),
    dispatch => bindActionCreators({ ...AccountStore.actionCreators, ...CommonStore.actionCreators, ...PaymentStore.actionCreators }, dispatch)
)(PayECheck);